module.exports = __webpack_public_path__ + "img/google-play-badge.7a1c5e2f.png";